import { isToday } from 'date-fns';
import { useCallback, useState } from 'react';

import { getLocalDateNoFormat } from '~/utils/date/date';

interface IDateFormValues {
  date: string;
}

const usePastDateSubmitGuard = <T extends IDateFormValues>(
  onSubmit: (values: T) => void | Promise<void>,
) => {
  const [pendingValues, setPendingValues] = useState<T | null>(null);

  const submitWithGuard = useCallback(
    (values: T) => {
      const parsedDate = getLocalDateNoFormat(values.date);

      if (parsedDate < new Date() && !isToday(parsedDate)) {
        setPendingValues(values);
        return;
      }

      onSubmit(values);
    },
    [onSubmit],
  );

  const clearPending = useCallback(() => {
    setPendingValues(null);
  }, []);

  const confirmPending = useCallback(async () => {
    if (!pendingValues) {
      return;
    }

    await onSubmit(pendingValues);
    setPendingValues(null);
  }, [onSubmit, pendingValues]);

  return {
    submitWithGuard,
    pendingValues,
    clearPending,
    confirmPending,
  };
};

export default usePastDateSubmitGuard;
